import React from 'react';

import type { ReactNode } from 'react';

import { Box, styled, Typography } from '@mui/material';

import UserChatHead from 'Assets/images/UserChatHead.svg';
import { Colors } from 'Themes/colors';

import { CloseIcon } from '@libs/shared/ui/icons';

import { Chip } from './chip';

const headSize = '55px';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 35px;
`;

const CloudContent = styled(Box)`
  background: ${Colors.white};
  position: relative;
  display: flex;
  padding: 25px 72px 25px 25px;
  border-radius: 22px;
  align-items: flex-start;
  gap: 21px;
  border: 1px solid ${Colors.lineGrey};

  &:before,
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    transform: translateY(calc(100%));
  }

  &:before {
    border: 20px solid;
    border-color: ${Colors.lineGrey} ${Colors.lineGrey} transparent transparent;
    right: ${headSize};
  }

  &:after {
    right: calc(${headSize} + 1px);
    border: 19px solid;
    border-color: ${Colors.white} ${Colors.white} transparent transparent;
  }
`;

const Close = styled(CloseIcon)`
  position: absolute;
  cursor: pointer;
  top: 15px;
  right: 15px;
`;

const Head = styled('img')`
  height: ${headSize};
  width: ${headSize};
`;

const InnerContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

type Props = {
  number: number;
  text: string;
  children?: ReactNode;
  onClose: () => void;
};

export const ChatCloud = ({ number, text, children, onClose }: Readonly<Props>) => {
  return (
    <Container>
      <CloudContent>
        <Chip color={Colors.red}>{number}</Chip>
        <InnerContent>
          <Typography fontStyle="italic">{text}</Typography>
          {children}
        </InnerContent>
        <Close onClick={onClose} />
      </CloudContent>
      <Head src={UserChatHead}></Head>
    </Container>
  );
};
